module.exports = __webpack_public_path__ + "img/icon_infos_orange.afcd7d67.svg";